export default __webpack_public_path__ + "static/media/chair.909cbb00.svg";